/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";
import objectPath from "object-path";
import {
  OverlayTrigger,
  Tooltip,
  DropdownButton,
  Dropdown,
  Popover,
} from "react-bootstrap";
import SVG from "react-inlinesvg";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { toAbsoluteUrl } from "../../../_helpers";
import { AsideSearch } from "./AsideSearch";
import { AsideMenu } from "./aside-menu/AsideMenu";
import { LanguageSelectorDropdown } from "../extras/dropdowns/LanguageSelectorDropdown";
import { QuickUserToggler } from "../extras/QuickUserToggler";
import { Brand } from "../brand/Brand";
import { KTUtil } from "./../../../_assets/js/components/util";
import { NavLink, useHistory, Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";

export function Aside() {
  const uiService = useHtmlClassService();
  const history = useHistory();

  const layoutProps = useMemo(() => {
    return {
      asideClassesFromConfig: uiService.getClasses("aside", true),
      asideSecondaryDisplay: objectPath.get(
        uiService.config,
        "aside.secondary.display"
      ),
      asideSelfMinimizeToggle: objectPath.get(
        uiService.config,
        "aside.self.minimize.toggle"
      ),
      extrasSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      extrasNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      extrasQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      extrasQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      extrasLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      extrasUserDisplay: objectPath.get(
        uiService.config,
        "extras.user.display"
      ),
    };
  }, [uiService]);

  const tabs = {
    tabId1: "kt_aside_tab_1",
    tabId2: "kt_aside_tab_2",
    tabId3: "kt_aside_tab_3",
    tabId4: "kt_aside_tab_4",
    tabId5: "kt_aside_tab_5",
    tabId6: "kt_aside_tab_6",
  };
  const [activeTab, setActiveTab] = useState();
  const handleTabChange = (id) => {
    setActiveTab(id);
    const asideWorkspace = KTUtil.find(
      document.getElementById("kt_aside"),
      ".aside-secondary .aside-workspace"
    );
    if (asideWorkspace) {
      KTUtil.scrollUpdate(asideWorkspace);
    }
  };

  const popover = (
    <Popover
      id="popover-basic"
      title="Popover right"
      style={{ width: "230px" }}
    >
      <ul style={{ marginTop: "10px" }}>
        <li
          // className={`menu-item  ${getMenuItemActive("/#")}`}
          // aria-haspopup="true"
          style={{ paddingBottom: "10px", paddingTop: "5px" }}
        >
          <NavLink className="menu-link" to="/botWeekly">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span
              className="menu-text"
              style={{ color: "black", fontWeight: "bold", fontSize: "13px" }}
            >
              기간 별 전체 실행 결과 현황
            </span>
          </NavLink>
        </li>
        <li
        // className={`menu-item  ${getMenuItemActive("/#")}`}
        // aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/botRate">
            <i className="menu-bullet menu-bullet-dot">
              <span />
            </i>
            <span
              className="menu-text"
              style={{ color: "black", fontWeight: "bold", fontSize: "13px" }}
            >
              Bot 별 실행률 현황
            </span>
          </NavLink>
        </li>
      </ul>
    </Popover>
  );
  const logoutClick = () => {
    // const toggle = document.getElementById("kt_quick_user_toggle");
    // console.log("toggle", toggle);
    // if (toggle) {
    // 	toggle.click();
    // }
    history.push("/logout");
  };

  return (
    <>
      {/* begin::Aside */}
      <div
        id="kt_aside"
        style={{
          backgroundImage:
            "linear-gradient(127deg, #ff6f5e, #ffa45e 51%, #ff5edb 99%)",
          width: "150px",
          paddingLeft: "10px",
          overflow: "auto",
        }}
        className={`aside aside-left d-flex ${layoutProps.asideClassesFromConfig}`}
      >
        {/* begin::Primary */}
        <div
          className="aside-primary d-flex flex-column align-items-center flex-row-auto"
          style={{ width: "130px" }}
        >
          <Brand />
          {/* begin::Nav Wrapper */}
          <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
            {/* begin::Nav */}
            <ul className="list-unstyled flex-column" role="tablist">
              {/* begin::Item */}
              <li
                className="nav-item mb-5 d-flex flex-column align-items-center"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Latest Project"
              >
                <NavLink
                  className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                  to={
                    localStorage.getItem("userRole") === "SystemAdmin"
                      ? "/bookSys"
                      : "/book"
                  }
                  onClick={() => handleTabChange(tabs.tabId1)}
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/Home/Book-open.svg")}
                    />
                  </span>
                </NavLink>
                <span style={{ fontWeight: "bold" }}>북 관리</span>
              </li>
              {/* end::Item */}

              {/* begin::Item */}
              <li
                className="nav-item mb-5 d-flex flex-column align-items-center"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Metronic Features"
              >
                {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">Bot 상태 관리</Tooltip>}
								> */}
                {/* <a
										href="/PageId24"
										className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
											tabs.tabId2 && "active"}`}
										data-toggle="tab"
										data-target={`#${tabs.tabId2}`}
										onClick={() => handleTabChange(tabs.tabId2)}
										role="tab"
									> */}
                <NavLink
                  // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                  // 	tabs.tabId2 && "active"}`}
                  className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                  to="/botMonitoring"
                  onClick={() => handleTabChange(tabs.tabId2)}
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/General/Thunder-move.svg"
                      )}
                    />
                  </span>
                </NavLink>
                {/* </a> */}
                <span style={{ fontWeight: "bold" }}>Bot 모니터링</span>
                {/* </OverlayTrigger> */}
              </li>
              {/* end::Item */}

              {/* begin::Item */}
              <li
                className="nav-item mb-5 d-flex flex-column align-items-center"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Latest Reports"
              >
                {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">예약 관리</Tooltip>}
								> */}
                <NavLink
                  to="/schedule"
                  className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                  // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                  // 	tabs.tabId3 && "active"}`}
                  data-toggle="tab"
                  data-target="#kt_aside_tab_3"
                  role="tab"
                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Communication/Clipboard-check.svg"
                      )}
                    />
                  </span>
                </NavLink>
                <span style={{ fontWeight: "bold" }}>예약 관리</span>
                {/* </OverlayTrigger> */}
              </li>
              {/* end::Item */}

              {/* begin::Item */}
              <li
                className="nav-item mb-5 d-flex flex-column align-items-center"
                data-toggle="tooltip"
                data-placement="rigth"
                data-container="body"
                data-boundary="window"
                title="Project Management"
              >
                <OverlayTrigger
                  trigger="click"
                  placement="right"
                  rootClose
                  overlay={popover}
                >
                  <div
                    // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                    // 	tabs.tabId4 && "active"}`}
                    className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                    // to="/main"
                    // onClick={() => handleTabChange(tabs.tabId4)}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Media/Equalizer.svg"
                        )}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
                <span style={{ fontWeight: "bold" }}>통계</span>
              </li>
              {/* end::Item */}

              {/* begin::Item */}
              {localStorage.getItem("userRole") === "BotAdmin" && (
                <li
                  className="nav-item mb-5 d-flex flex-column align-items-center"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="User Management"
                >
                  {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">Bot 관리</Tooltip>}
								> */}
                  <NavLink
                    // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                    // 	tabs.tabId5 && "active"}`}
                    className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                    to="/botManage"
                    onClick={() => handleTabChange(tabs.tabId5)}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Thunder.svg"
                        )}
                      />
                    </span>
                  </NavLink>
                  <span style={{ fontWeight: "bold" }}>Bot 관리</span>
                  {/* </OverlayTrigger> */}
                </li>
              )}
              {/* end::Item */}
              {localStorage.getItem("userRole") === "BotAdmin" && (
                <div>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Finance & Accounting"
                  >
                    {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">공지사항</Tooltip>}
								> */}
                    <NavLink
                      // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                      // 	tabs.tabId6 && "active"}`}
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/licenseManage"
                      // onClick={() => handleTabChange(tabs.tabId6)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Clipboard.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold" }}>라이선스 관리</span>
                    {/* </OverlayTrigger> */}
                  </li>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Finance & Accounting"
                  >
                    {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">공지사항</Tooltip>}
								> */}
                    <NavLink
                      // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                      // 	tabs.tabId6 && "active"}`}
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/licenseBuyMng"
                      // onClick={() => handleTabChange(tabs.tabId6)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Duplicate.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold" }}>
                      라이선스 구매관리
                    </span>
                    {/* </OverlayTrigger> */}
                  </li>
                </div>
              )}
              {/* begin::Item */}
              {localStorage.getItem("userRole") !== "Bot" && (
                <li
                  className="nav-item mb-5 d-flex flex-column align-items-center"
                  data-toggle="tooltip"
                  data-placement="rigth"
                  data-container="body"
                  data-boundary="window"
                  title="Finance & Accounting"
                >
                  {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">공지사항</Tooltip>}
								> */}
                  <NavLink
                    // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                    // 	tabs.tabId6 && "active"}`}
                    className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                    to="/notice"
                    onClick={() => handleTabChange(tabs.tabId6)}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/General/Notifications1.svg"
                        )}
                      />
                    </span>
                  </NavLink>
                  <span style={{ fontWeight: "bold" }}>공지사항</span>
                  {/* </OverlayTrigger> */}
                </li>
              )}
              {localStorage.getItem("userRole") === "SystemAdmin" && (
                <div>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="User Management"
                  >
                    {/* <OverlayTrigger
									placement="right"
									overlay={<Tooltip id="latest-project">Bot 관리</Tooltip>}
								> */}
                    <NavLink
                      // className={`nav-link btn btn-icon btn-clean btn-lg mb-1 ${activeTab ===
                      // 	tabs.tabId5 && "active"}`}
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/botAdminManage"
                      onClick={() => handleTabChange(tabs.tabId5)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Thunder.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold" }}>Bot관리자 관리</span>
                    {/* </OverlayTrigger> */}
                  </li>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Finance & Accounting"
                  >
                    <NavLink
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/licenseSysManage"
                      onClick={() => handleTabChange(tabs.tabId6)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Clipboard.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold" }}>라이선스 관리</span>
                  </li>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Finance & Accounting"
                  >
                    <NavLink
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/licenseSysBuyMng"
                      onClick={() => handleTabChange(tabs.tabId6)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Duplicate.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold", marginLeft: "3px" }}>
                      라이선스 구매관리
                    </span>
                  </li>
                  <li
                    className="nav-item mb-5 d-flex flex-column align-items-center"
                    data-toggle="tooltip"
                    data-placement="rigth"
                    data-container="body"
                    data-boundary="window"
                    title="Finance & Accounting"
                  >
                    <NavLink
                      className={`nav-link btn btn-icon btn-clean btn-lg mb-1 active`}
                      to="/licenseReqMng"
                      onClick={() => handleTabChange(tabs.tabId6)}
                    >
                      <span className="svg-icon svg-icon-lg">
                        <SVG
                          src={toAbsoluteUrl(
                            "/media/svg/icons/General/Notifications1.svg"
                          )}
                        />
                      </span>
                    </NavLink>
                    <span style={{ fontWeight: "bold", marginLeft: "3px" }}>
                      라이선스 문의관리
                    </span>
                  </li>
                </div>
              )}

              {/* end::Item */}
            </ul>
            {/* end::Nav */}
          </div>
          {/* end::Nav Wrapper */}

          {/* begin::Footer */}
          {/* <div className="aside-footer flex-column align-items-center flex-column-auto py-4 py-lg-10">
           
            <div>
              <div>

                <div
                  className={`nav-link btn btn-icon btn-clean btn-lg mb-1 inactive`}
                  onClick={logoutClick}

                >
                  <span className="svg-icon svg-icon-lg">
                    <SVG
                      src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                    />
                  </span>
                </div>
              </div>
              <span style={{ fontWeight: "bold" }}>로그아웃</span>
            </div>

          </div> */}
        </div>
      </div>
      {/* end::Aside */}
    </>
  );
}
